import { ErrorMessage } from "../../utlis/function";
import GoogleAddressAutocomplete from "./GoogleAddressAutocomplete";

const AddressFieldsSection = ({
  label,
  type = "added",
  value,
  errors = {},
  onChange,
  onSelect,
  onZipChange,
  onRemove,
  removeLabel = "Remove address",
  showRemove = false,
  editableZip = false,
}) => {
  return (
    <div className="relative rounded-lg border border-gray-100 p-4 mt-5">
      {showRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label={removeLabel}
          className="absolute right-3 top-3 text-red-500 hover:text-red-700"
        >
          ✕
        </button>
      )}

      <div className="space-y-4">
        <div>
          <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2 pr-8">
            {label}
          </label>
          <GoogleAddressAutocomplete
            type={type}
            value={value.address}
            onChange={onChange}
            onSelect={onSelect}
          />
          <ErrorMessage message={errors.address} />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
              City
            </label>
            <input
              value={value.city || ""}
              readOnly
              placeholder="City"
              className="w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black border border-gray-200 focus:outline-none"
            />
            <ErrorMessage message={errors.city} />
          </div>

          <div>
            <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
              State
            </label>
            <input
              value={value.state || ""}
              readOnly
              placeholder="State"
              className="w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black border border-gray-200 focus:outline-none"
            />
            <ErrorMessage message={errors.state} />
          </div>

          <div>
            <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
              Zip Code
            </label>
            <input
              value={value.zipCode || ""}
              readOnly={!editableZip}
              onChange={(e) => onZipChange?.(e.target.value)}
              placeholder="Zip code"
              className="w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black border border-gray-200 focus:outline-none"
            />
            {/* <ErrorMessage message={errors.zipCode} /> */}
          </div>

          <div>
            <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
              Country
            </label>
            <input
              value={value.country || ""}
              readOnly
              placeholder="Country"
              className="w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black border border-gray-200 focus:outline-none"
            />
            <ErrorMessage message={errors.country} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddressFieldsSection;
